const sendPhotoData = [
    {
        id: 1,
        img: "/images/ic_woman_front.svg",
        label: "front_pic",
        text: "عکس از رو به رو"
    },
    {
        id: 2,
        img: "/images/ic_woman_side.svg",
        label: "side_pic",
        text: "عکس از کنار"
    },
    {
        id: 3,
        img: "/images/ic_woman_front.svg",
        label: "back_pic",
        text: "عکس از پشت"
    }
]

export default sendPhotoData;